// The white card every reader block sits on.
export const readerCardProps = {
  backgroundColor: 'white',
  borderRadius: '24px',
  padding: { base: '24px', md: '36px' },
  boxShadow: '0px 10px 34px rgba(14, 0, 98, 0.06)',
} as const;
